export default {
  title: '{{plan}} is actief',
  plan: 'Abonnement: {{plan}}',
  free_until: 'Gratis tot {{date}}',
  continue: 'Doorgaan',
};
